module.exports = __webpack_public_path__ + "img/murano20.c09031da.png";